import {
  Disclaimer,
  Pill,
  TooltipWrapper,
  isAdmin,
  lightTheme,
  renderMiles,
} from '@vgrubs/components';

/**
 * Gray "3.37 miles" pill. `miles` is the distance the vDrive strategy works
 * on; admins also get the distance the DSP reported on hover, but only when
 * it tells them something (present and more than 0.1 mi off). Some DSPs
 * report 0, which is "no distance", not a real reading.
 */
export const DistancePill = ({
  miles,
  dspMiles,
}: {
  miles: number;
  dspMiles?: number | null;
}) => {
  const showDsp =
    isAdmin &&
    !!dspMiles &&
    dspMiles > 0 &&
    Math.abs(dspMiles - miles) > 0.1;

  const pill = (
    <Pill $background={lightTheme.gray}>
      <Disclaimer $m="0">
        {miles} {renderMiles(miles)}
      </Disclaimer>
    </Pill>
  );

  if (!showDsp) return pill;

  return (
    <TooltipWrapper
      tooltip={`Distance used by the delivery strategy.<br/>DSP reported: ${dspMiles} ${renderMiles(
        dspMiles
      )}`}
    >
      {pill}
    </TooltipWrapper>
  );
};
